import { useEffect } from "react";
import type { BootstrapPayload } from "../../shared/contracts/bootstrap.js";
import { loadBootstrap } from "../api/bootstrap-api.js";
import { deviceAccountCache } from "../data/local-database.js";

/** Refresh identity without replacing a round or disturbing queued local scores. */
export function useProfileRefresh(
  accountId: string,
  authenticated: boolean,
  setBootstrap: (data: BootstrapPayload) => void,
): void {
  useEffect(() => {
    if (!authenticated) return;
    let active = true;
    let revision = 0;
    const refresh = async () => {
      const requested = ++revision;
      try {
        const data = await loadBootstrap();
        if (!active || requested !== revision || data.account.id !== accountId)
          return;
        setBootstrap(data);
        await deviceAccountCache.save(data);
      } catch {
        /* A saved profile must not interrupt offline scorekeeping. */
      }
    };
    window.addEventListener("fairway:profile-changed", refresh);
    return () => {
      active = false;
      window.removeEventListener("fairway:profile-changed", refresh);
    };
  }, [accountId, authenticated, setBootstrap]);
}
